<template>
  <BModal
    id="modal-guide-book-ctwa"
    ref="modal-guide-book-ctwa"
    no-stacking
    centered
    hide-footer
    hide-header
    hide-header-close
    no-close-on-backdrop
    no-close-on-esc
    size="lg"
    modal-class="rounded-4xl"
    content-class="!rounded-2xl !border-gray-200 !border-solid !border-[6px] !bg-gradient-to-b !from-[#7CBCFE]/20 !to-white"
  >
    <!-- Close Button -->
    <BButton
      variant="link"
      class="position-absolute"
      style="top: 16px; right: 16px; z-index: 10; padding: 8px;"
      @click="$refs['modal-guide-book-ctwa'].hide()"
    >
      <feather-icon
        icon="XCircleIcon"
        size="24"
        class="text-black"
      />
    </BButton>
    <section class="relative p-2">
      <!-- Header Section with Background -->
      <img
        src="https://storage.googleapis.com/komerce/assets/LP-Komads/header-komads-new.svg"
        alt="Komads"
        class="rounded-t-xl mx-auto"
      >
      <div class="flex flex-col gap-8">
        <!-- Steps List -->
        <div
          class="bg-[#CEEEFF] rounded-xl shadow-sm p-2 border border-solid flex flex-col gap-2"
        >
          <h2 class="font-bold text-lg">
            Persiapan penautuan akun Facebook X Komads CTWA
          </h2>
          <ol class="!list-decimal px-2">
            <li
              v-for="(step, index) in preparationSteps"
              :key="`step-${index}`"
            >
              {{ step }}
            </li>
          </ol>
        </div>

        <!-- Help Section -->
        <div
          class="bg-white rounded-xl shadow-sm p-2 border border-solid flex flex-col gap-2"
        >
          <h2 class="font-bold text-lg">
            Bantuan
          </h2>

          <div
            v-for="(help, index) in helpLinks"
            :key="`help-${index}`"
          >
            <span>{{ help.text }} </span>
            <a
              :href="help.url"
              class="text-[#08A0F7] hover:text-blue-400 font-semibold"
              target="_blank"
            >{{ help.linkText }}</a>
          </div>
        </div>
      </div>
    </section>
  </BModal>
</template>

<script>
import { BModal, BButton } from 'bootstrap-vue'

export default {
  name: 'ModalGuideBookCTWA',
  components: {
    BModal,
    BButton,
  },
  data() {
    return {
      preparationSteps: [
        'Siapkan Facebook yang memiliki akses pengelola penuh di Fanspage yang akan kamu gunakan untuk beriklan',
        'Pastikan Fanspage tersebut ada di Facebook yang akan kamu gunakan untuk ditautkan dengan Komads CTWA',
        'Pastikan Facebook dan Fanspage yang akan kamu gunakan belum terhubung dengan akun Komads CTWA lainnya',
        'Tautkan Whatsapp Bisnis yang akan kamu gunakan untuk menerima pesan dari pembeli ke Fanspage yang akan kamu gunakan untuk beriklan',
      ],
      helpLinks: [
        {
          text: 'Belum memiliki Facebook?',
          url: 'https://www.facebook.com/reg/?locale=id_ID',
          linkText: 'Buat Facebook',
        },
        {
          text: 'Akun Facebook-mu belum akses penuh di Fanspage? Lihat caranya',
          url:
            'https://id-id.facebook.com/business/help/152071822895768?id=418112142508425',
          linkText: 'di sini',
        },
        {
          text: 'Bingung cara bikin Fanspage? Lihat caranya',
          url:
            'https://id-id.facebook.com/business/help/1199464373557428?id=418112142508425',
          linkText: 'di sini',
        },
        {
          text:
            'Nomor Whatsapp Bisnismu belum tertaut di Fanspage? Lihat caranya',
          url:
            'https://id-id.facebook.com/business/help/1583303048513172?id=2129163877102343',
          linkText: 'di sini',
        },
      ],
    }
  },
  methods: {
    /**
     * Hide the modal
     * Public method to close the modal from parent component
     */
    hide() {
      this.$refs['modal-guide-book-ctwa'].hide()
    },
  },
}
</script>

<style scoped>
/* Custom styles for gradient text */
.gradient-text {
  background: linear-gradient(45deg, #ffd700, #ffa500);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Custom gap utility for older Bootstrap versions */
.gap-3 > * + * {
  margin-left: 1rem;
}

/* Ensure proper text rendering for gradient */
.gradient-text {
  display: inline-block;
}
</style>
